import { FC } from 'react'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerText from '../../../components/custom_components/Text'
import { TShirtSize } from '../../../components/util/types'
import '../pyramids.less'

interface Props {
  description: string
  type: 'recommended' | 'current' | 'forecast' | 'past'
  noMarginBottom?: boolean
  small?: boolean
  ml?: TShirtSize
  mr?: TShirtSize
}

export const PyramidsLegendItem: FC<Props> = ({ type, description, noMarginBottom, small, ml, mr }) => {
  return (
    <PerFlexRow
      mb={noMarginBottom ? undefined : 'xs'}
      ml={ml}
      mr={mr}
      align="middle"
      className={'per-pyramids-legendItem ' + (small ? 'small' : undefined)}
    >
      <div className="per-pyramids-legendItem-indicator--wrapper">
        <div className={'per-pyramids-legendItem-indicator--' + type} />
      </div>
      <PerText ml="s" fontSize={small ? 's' : undefined} color={small ? 'secondary' : undefined}>
        {description}
      </PerText>
    </PerFlexRow>
  )
}
